import { render, staticRenderFns } from "./PicInfo.vue?vue&type=template&id=8cd8ce9e&scoped=true&"
import script from "./PicInfo.vue?vue&type=script&lang=js&"
export * from "./PicInfo.vue?vue&type=script&lang=js&"
import style0 from "./PicInfo.vue?vue&type=style&index=0&id=8cd8ce9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd8ce9e",
  null
  
)

export default component.exports